module.exports = __webpack_public_path__ + "img/search-icon.dcc0b796.svg";